<template lang="pug">

div
    .ui.secondary.menu

        router-link.item(:to='{ name: "settings/moco-sync" }') MOCO Synchronisierung
        router-link.item(:to='{ name: "settings/moco-settings" }') MOCO Konfiguration
        router-link.item(:to='{ name: "settings/databases" }') ZMÜK Datenbanken
        router-link.item(:to='{ name: "settings/services-status" }') ZMÜK Status

    .ui.divider

</template>

<script>

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {
            
        }

    }

</script>

